// src/infra/api/templateGenerateApi.js
import axiosInstance from "../axios";

/**
 * Gera e baixa PDF do template final (backend retorna application/pdf).
 * Endpoint oficial: GET /api/{tenant}/amostras/{id}/relatorio/pdf
 *
 * Importante: usa responseType "blob" para download.
 */
export const baixarPdfTemplatePorAmostra = async ({ tenant, amostraId }) => {
    try {
        if (!tenant) throw new Error("Tenant não informado.");
        if (!amostraId) throw new Error("AmostraId não informado.");

        const resp = await axiosInstance.get(
            `/amostras/${encodeURIComponent(amostraId)}/relatorio/pdf`,
            { responseType: "blob" }
        );

        // O backend manda Content-Disposition com filename, mas nem sempre o browser expõe.
        // Vamos tentar pegar se existir; caso não, usamos fallback.
        const contentDisposition = resp?.headers?.["content-disposition"] || "";
        const match = contentDisposition.match(/filename="?([^"]+)"?/i);
        const filename = match?.[1] || `relatorio-${amostraId}.pdf`;

        return { blob: resp.data, filename };
    } catch (error) {
        // Quando responseType: "blob", o corpo do erro do backend também chega como Blob.
        // É necessário ler o Blob como texto para extrair a mensagem JSON.
        const errData = error?.response?.data;
        if (errData instanceof Blob) {
            try {
                const text = await errData.text();
                const parsed = JSON.parse(text);
                throw new Error(parsed?.message || "Falha ao baixar PDF do template.");
            } catch (parseErr) {
                if (parseErr?.message && parseErr.message !== "Falha ao baixar PDF do template.") {
                    throw parseErr;
                }
            }
        }
        const msg =
            errData?.message ||
            error?.message ||
            "Falha ao baixar PDF do template.";
        throw new Error(msg);
    }
};




export async function baixarRelatorioEtePdf(amostraEntradaId, amostraSaidaId) {
    const amostraId = amostraEntradaId || amostraSaidaId || undefined;
    const res = await axiosInstance.get("/templates-generate/ete/pdf", {
        params: { amostraId, amostraEntradaId, amostraSaidaId },
        responseType: "blob",
        headers: { Accept: "application/pdf" },
    });
    return res.data; // Blob
}

/**
 * Baixa Relatório ETE (HTML) como Blob
 * GET /{tenant}/templates-generate/ete/html?amostraEntradaId=...&amostraSaidaId=...
 */
export async function baixarRelatorioEteHtml(amostraEntradaId, amostraSaidaId) {
    const amostraId = amostraEntradaId || amostraSaidaId || undefined;
    const res = await axiosInstance.get("/templates-generate/ete/html", {
        params: { amostraId, amostraEntradaId, amostraSaidaId },
        responseType: "blob",
        headers: { Accept: "text/html" },
    });
    return res.data; // Blob
}


export default {
    baixarPdfTemplatePorAmostra,
    baixarRelatorioEtePdf,
    baixarRelatorioEteHtml
};
